export type Vehicle = {
  id: string;
  organizationId: string;
  customerId: string | null;
  plate: string | null;
  brand: string | null;
  model: string | null;
  year: number | null;
  vin: string | null;
  color: string | null;
  mileage: number | null;
  notes: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
};

export type VehicleDraft = {
  id?: string;
  customerId: string | null;
  plate: string;
  brand: string;
  model: string;
  year: string;
  vin: string;
  color: string;
  mileage: string;
  notes: string;
};

export type VehicleListItem = {
  id: string;
  customerId: string | null;
  plate: string | null;
  brand: string | null;
  model: string | null;
  year: number | null;
  vin: string | null;
  color: string | null;
  mileage: number | null;
  notes: string | null;
  isActive: boolean;
};

export type VehicleSearchQuery = {
  customerId?: string | null;
  search?: string | null;
};

/** Display: "Ford Focus 2018 · AB123CD" or "Vehículo sin patente". */
export function vehicleDisplay(v: Pick<Vehicle, 'brand' | 'model' | 'year' | 'plate'>): string {
  const parts: string[] = [];
  if (v.brand) parts.push(v.brand);
  if (v.model) parts.push(v.model);
  if (v.year) parts.push(String(v.year));
  const desc = parts.join(' ').trim();
  const plate = v.plate?.trim();
  if (desc && plate) return `${desc} · ${plate}`;
  if (desc) return desc;
  if (plate) return plate;
  return 'Vehículo sin datos';
}

/** Short display: just the plate, or "Sin patente". */
export function vehiclePlateLabel(v: Pick<Vehicle, 'plate'>): string {
  return v.plate?.trim() || 'Sin patente';
}
